module.exports = __webpack_public_path__ + "img/3_1.10d562e5.png";